import React from "react";
import {
  Button,
  ComposedModal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "@carbon/react";

export const CreateInvoice = ({ isModalOpen, closeModal }) => {
  return (
    <ComposedModal open={isModalOpen} onClose={closeModal}>
      <ModalHeader label="">
        <h1>Create a invoice</h1>
      </ModalHeader>

      <ModalBody>
        <p className="modal--content">Form inputs</p>
      </ModalBody>

      <ModalFooter>
        <Button kind="danger" onClick={closeModal}>
          Close Form
        </Button>

        <Button
          kind="primary"
          onClick={() => {
            alert("Sending to server...");
            closeModal();
          }}
        >
          Save
        </Button>
      </ModalFooter>
    </ComposedModal>
  );
};
